module.exports = __webpack_public_path__ + "static/media/portfolio-banner-info-img4.c0c69b44.png";